export default __webpack_public_path__ + "static/media/pintrest.2411f4ca.svg";